// src/views/auth/forgotPassword/ForgotPasswordPage.jsx
import React from "react";
import ForgotPassword from "./index";

export default function ForgotPasswordPage() {
  return <ForgotPassword />;
}
